import { render, staticRenderFns } from "./DockingHistory.vue?vue&type=template&id=858d5d1a&"
import script from "./DockingHistory.vue?vue&type=script&lang=js&"
export * from "./DockingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports